import * as React from 'react';
import { SVGProps } from 'react';

const SvgSpiritualSupport = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 42 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M29.413 28.61v-.663a7.47 7.47 0 0 0-7.468-7.468h-1.864a7.47 7.47 0 0 0-7.468 7.468v.69M25.79 12.79v2.881a4.779 4.779 0 0 1-4.781 4.782 4.779 4.779 0 0 1-4.782-4.782v-2.88"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M16.227 15.662v-2.88A4.779 4.779 0 0 1 21.01 8a4.779 4.779 0 0 1 4.781 4.781v2.881m14.537 17.323V27.99a6.378 6.378 0 0 0-6.38-6.38h-1.6a6.367 6.367 0 0 0-4.463 1.82m9.35-8.395V17.5a4.085 4.085 0 0 1-4.083 4.083A4.085 4.085 0 0 1 29.07 17.5v-2.466"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M29.07 17.492v-2.466a4.085 4.085 0 0 1 4.082-4.083 4.085 4.085 0 0 1 4.083 4.083v2.466"
    />
    <path fill={props.fill} d="M1 32.984v-4.4h35.616l4.384 4.4H1Z" />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M14.062 23.378A6.386 6.386 0 0 0 9.643 21.6h-1.6a6.378 6.378 0 0 0-6.38 6.381v.593m11.268-13.539V17.5a4.085 4.085 0 0 1-4.083 4.083A4.085 4.085 0 0 1 4.765 17.5v-2.466"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M4.765 17.492v-2.466a4.085 4.085 0 0 1 4.083-4.083 4.085 4.085 0 0 1 4.083 4.083v2.466"
    />
  </svg>
);

export default SvgSpiritualSupport;
